/* eslint-disable array-bracket-newline */
/**
 * Implements a chart picker
 * Contains a list of chart modes
 */
import { Link, matchPath, useLocation, useParams } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import Text from '../../atoms/Text';
import {
  COMPETITION_ENABLED,
  DEFAULT_OVERVIEW_WALLET,
} from '../../helpers/constants';
import {
  newPairsLink,
  bigTradesLink,
  walletOverviewLink,
  competitionLink,
} from './helpers';
import { defaultNewPairstSort } from '../../pages/NewPairsPage';
import { defaultBigTradesSort } from '../../pages/BigTradesPage';

import './styles.scss';

const NavigationLinks = () => {
  const params = useParams();
  const location = useLocation();
  const isNewPairsActive = matchPath('/new-pairs', location.pathname ?? '');
  const isBigTradesActive = matchPath('/big-trades', location.pathname ?? '');

  const isWalletOverviewActive = matchPath(
    '/:lang/wallet-overview/:chain/:address',
    location.pathname ?? ''
  );

  const isCompetitionActive = matchPath(
    '/competition/:exchange',
    location.pathname ?? ''
  );

  return (
    <div className='research'>
      <Link
        to={`/new-pairs?chain=ETH&page=1&sort=${defaultNewPairstSort}`}
        className={`research__block ${
          isNewPairsActive ? 'research__block--active' : ''
        }`}
      >
        <div className={newPairsLink.icon} />
        <Text size={14} className='research__block__text'>
          {newPairsLink.name}
        </Text>
      </Link>
      <Link
        to={`/big-trades?chain=ETH&sort=${defaultBigTradesSort}`}
        className={`research__block ${
          isBigTradesActive ? 'research__block--active' : ''
        }`}
      >
        <div className={bigTradesLink.icon} />
        <Text size={14} className='research__block__text'>
          {bigTradesLink.name}
        </Text>
      </Link>
      <Link
        to={`/en/wallet-overview/${
          params.chain || 'ETH'
        }/${DEFAULT_OVERVIEW_WALLET}`}
        className={`research__block ${
          isWalletOverviewActive ? 'research__block--active' : ''
        }`}
      >
        <div className={walletOverviewLink.icon} />
        <Text size={14} className='research__block__text'>
          {walletOverviewLink.name}
        </Text>
      </Link>
      {COMPETITION_ENABLED ? (
        <Link
          to='/competition/binance'
          className={`research__block ${
            isCompetitionActive ? 'research__block--active' : ''
          }`}
        >
          <div className={competitionLink.icon} />
          <Text size={14} className='research__block__text'>
            {competitionLink.name}
          </Text>
        </Link>
      ) : (
        <>
          <div
            className='research__block'
            data-for='competition-tooltip'
            data-tip="Exciting trading competition<br>coming up soon!<br>Stay tuned so you don't miss out."
            style={{ cursor: 'help', filter: 'brightness(100%)' }}
          >
            <div className={competitionLink.icon} />
            <Text size={14} className='research__block__text'>
              {competitionLink.name}
            </Text>
          </div>
          <ReactTooltip
            id='competition-tooltip'
            place='bottom'
            effect='solid'
            multiline
            className='actions__tooltip text_tooltip'
          />
        </>
      )}
    </div>
  );
};

export default NavigationLinks;
